<template>
    <div v-if="body_show">
        <h2 class="h2">请进行手机登陆</h2>
        <div class="supervisor-verify">
            <div class="supervisor-row">
                <img class="tel" src="@a/tel.png" >
                <input type="number" placeholder="填写手机号" v-model="phone" />
            </div>
            <div class="supervisor-row">
                <img class="code" src="@a/code.png" >
                <input type="number" placeholder="请填写验证码" v-model="code" />
                <button @click="sendVerificationCode(this)" :disabled="disabled">{{verificationCode}}</button>
            </div>
            <a :class="['next',phone && code?'actice':'']" href="javascript:;" @click="phone && code?submitHandle():''">下一步</a>
            <p>请使用辅导后台填写的手机号码</p>
        </div>
    </div>
</template>

<script>
import { login,sendmsg,subcode } from "@/api/totoring"
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            body_show:false,
            disabled:false,
            verificationCode:'获取验证码',
            countdown:60,
            phone:null,
            code:null
        }
    },
    methods:{
        pullData() {
            login()
            .then((data) => {
                shareCon("totoring", this);
                this.body_show = true;
            })
        },
        submitHandle(){
            subcode({
                tel:this.phone,
                code:this.code
            })
            .then((data) => {
                console.log(data);
                if(data.msg == '操作失败'){
                    this.$toast(data.data.msg);
                }else{
                    this.$toast(data.msg);
                }
            })
        },
        sendVerificationCode(val){
            let reg = /^1[3|4|5|7|8][0-9]{9}$/; //验证规则
            let flag = reg.test(this.phone); //true
            if(flag){
                this.setTime(val);
                sendmsg({
                    tel: this.phone,
                })
                .then((data) => {
                    this.$toast('发送成功，请注意查收！');
                })
            }else{
                this.$toast('您输入的手机号不正确！(ㄒoㄒ) ~~');
            }
        },
        setTime(val){
            
            let this_ = this;
            if (this.countdown == 0) {
                this.disabled = false;
                this.verificationCode="获取验证码";
                this.countdown = 60;
            } else {
                this.disabled = true;
                this.verificationCode =  this.countdown + "s";
                this.countdown--;
                setTimeout(function() {
                    this_.setTime(val)
                },1000)
            }
        }
    },
    created() {
      this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.h2{
    font-size: 34px;
    color: #333;
    text-align: center;
    margin-top: 200px;
}
.supervisor-verify{
    margin: 80px 86px auto 86px;
    .supervisor-row{
        border-bottom: 1px solid #ccc;
        height: 90px;
        line-height: 90px;
        text-align: left;
        input{
            background: none;
            font-size: 32px;
            color: #333;
            height: 40px;
            vertical-align: middle;
            width: 350px;
            border: none;
            margin-bottom: 0;
        }
        img{
            width: 35px;
            height: 40px;
            margin-right: 23px;
            border: 0;
        }
        button{
            width:146px;
            height:48px;
            border:1px solid rgba(235,80,50,1);
            border-radius:2px;
            line-height: 48px;
            color: #EB5032;
            font-size: 24px;
            text-align: center;
            float: right;
            margin-right: 10px;
            padding: 0;
            margin: 0;
            margin-top: 20px;
            background: none;
        }
    }
    .next{
        display: block;
        text-align: center;
        font-size: 32px;
        color: #fff;
        background-color: #BABABA;
        line-height:80px;
        background:rgba(186,186,186,1);
        border-radius:8px;
        margin: 55px auto 20px;
    }
    .next.actice{
        background-color: #EB5032;
    }
    p{
        font-size: 24px;
        color: #999;
        text-align: center;
    }
}

</style>
